export default __webpack_public_path__ + "static/Dashly-9f8e96a364b7ef3ef0141887ba671702.png";